import { render, staticRenderFns } from "./QuotesBill.vue?vue&type=template&id=74d6babb&scoped=true"
import script from "./QuotesBill.vue?vue&type=script&lang=js"
export * from "./QuotesBill.vue?vue&type=script&lang=js"
import style0 from "./QuotesBill.vue?vue&type=style&index=0&id=74d6babb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74d6babb",
  null
  
)

export default component.exports